import React from 'react';
import { 
  LayoutDashboard, 
  Package, 
  MapPin, 
  FileText, 
  User, 
  Lock, 
  LogOut, 
  Headphones 
} from 'lucide-react';

const AccountSidebar = ({ activeTab, setActiveTab, onLogout }) => {
  const menuItems = [
    { id: 'dashboard', label: 'Dashboard', icon: LayoutDashboard },
    { id: 'orders', label: 'My Orders', icon: Package },
    { id: 'addresses', label: 'Saved Addresses', icon: MapPin },
    { id: 'bills', label: 'Bills', icon: FileText },
    { id: 'profile', label: 'Profile Information', icon: User },
    { id: 'security', label: 'Security', icon: Lock }
  ];

  return (
    <div className="account-sidebar">
      <div className="sidebar-nav-list">
        {menuItems.map(item => {
          const Icon = item.icon;
          return (
            <button
              key={item.id}
              onClick={() => setActiveTab(item.id)}
              className={`sidebar-nav-item ${activeTab === item.id ? 'active' : ''}`}
            >
              <Icon size={18} />
              <span>{item.label}</span>
            </button>
          );
        })}
        <button
          onClick={onLogout}
          className="sidebar-nav-item logout-btn"
        >
          <LogOut size={18} style={{ color: '#ef4444' }} />
          <span style={{ color: '#ef4444' }}>Logout</span>
        </button>
      </div>

      <div className="need-help-card">
        <div className="need-help-icon-wrapper">
          <Headphones size={20} />
        </div>
        <h4>Business Support</h4>
        <p>Need assistance with orders, billing, or inventory?</p>
        <button 
          onClick={() => window.location.href = 'mailto:support@regardtrader.in?subject=REGARD TRADERS Support Request'} 
          className="btn-contact"
        >
          Contact Support
        </button>
      </div>
    </div>
  );
};

export default AccountSidebar;
